var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { fullScreen$, resize$ } from "../../../../events/eventsBrowser";
import { IdStyles } from "../../../../less/IdStyles";
import { selectActiveTutorialConfig } from "../../../../selectors/selectTutorial";
import { utilSVG } from "../../../../utils/svg/utilSVG";
import { BouncingArrow } from "../../../generic/common/BouncingArrow";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { ArrowAnimationName } from "../../TutorialConfig";
import { TutorialBackground } from "../TutorialBackground";
import { TutorialBlockInputs } from "../TutorialBlockInputs";
import { TutorialCharacterHelper } from "../TutorialCharacterHelper";
var TutorialFocusOnDomDOM = /** @class */ (function (_super) {
    __extends(TutorialFocusOnDomDOM, _super);
    function TutorialFocusOnDomDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderContent = function () {
            var _a = _this.props, tutorialConfig = _a.tutorialConfig, focusElement = _a.focusElement;
            if (tutorialConfig.isEmpty) {
                return React.createElement(React.Fragment, null);
            }
            var rootPosition = focusElement.getBoundingClientRect();
            var contentStyle = {
                left: 50 + "%",
                position: "absolute",
                top: tutorialConfig.descriptionTopPosition + "%",
            };
            var arrowLeftPosition = tutorialConfig.arrowAnimation === ArrowAnimationName.ANIMATE_LEFT
                ? rootPosition.left - rootPosition.width / 2 + "px"
                : rootPosition.left + rootPosition.width + "px";
            var arrowStyle = {
                animationName: tutorialConfig.arrowAnimation,
                left: arrowLeftPosition,
                top: rootPosition.top - rootPosition.height / 2 + "px",
            };
            var ellipsePath = utilSVG.rectToEllipseToPath(rootPosition, 0.55, 10);
            return (React.createElement("div", null,
                React.createElement(TutorialBackground, { rect: rootPosition, ellipsePath: ellipsePath }),
                tutorialConfig.idLocaDescription && (React.createElement("div", { className: "flex flex--centered", style: contentStyle },
                    React.createElement(TutorialCharacterHelper, { locaDescription: tutorialConfig.idLocaDescription }))),
                tutorialConfig.nextStep && (React.createElement(BouncingArrow, { icon: IdIcon.RedArrowIcn, iconStyle: IdStyles.IconExtraLarge, containerCSSProps: arrowStyle }))));
        };
        // this is necessary to update component positions
        _this.onResize = function () {
            _this.setState({});
        };
        return _this;
    }
    TutorialFocusOnDomDOM.prototype.componentDidMount = function () {
        this.resizeSubscription$ = resize$.subscribe(this.onResize);
        this.fullScreenSubscription$ = fullScreen$.subscribe(this.onResize);
    };
    TutorialFocusOnDomDOM.prototype.componentWillUnmount = function () {
        this.resizeSubscription$.unsubscribe();
        this.fullScreenSubscription$.unsubscribe();
    };
    TutorialFocusOnDomDOM.prototype.render = function () {
        var _a = this.props, tutorialConfig = _a.tutorialConfig, shouldRender = _a.shouldRender, focusElement = _a.focusElement;
        return tutorialConfig && shouldRender && focusElement ? (React.createElement("div", null, this.renderContent())) : (React.createElement(TutorialBlockInputs, null));
    };
    return TutorialFocusOnDomDOM;
}(React.Component));
var mapState = function (state) {
    var tutorialConfig = selectActiveTutorialConfig(state);
    var shouldRender = state.viewport.centerPosition == undefined;
    // in case when focus element wasn't rendered yet
    var focusElement;
    if (tutorialConfig && tutorialConfig.focusId) {
        focusElement = document.getElementById("" + tutorialConfig.focusId);
    }
    return {
        focusElement: focusElement,
        shouldRender: shouldRender,
        tutorialConfig: tutorialConfig,
    };
};
export var TutorialFocusOnDom = connect(mapState, undefined)(TutorialFocusOnDomDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/tutoria-dom/TutorialFocusOnDom.tsx
// module id = 1139
// module chunks = 3